import {createActions} from 'client/framework';

export default createActions(null, [
  'DELETE_ASSIGNMENT',
  'SET_ASSIGNMENT_TO_DELETE',
  'SET_LAST_VALID_DATES',
  'UPDATE_VIEW_LOADED_AT_DATETIME'
]);
